"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _typography = _interopRequireDefault(require("@hig/typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));

var _excluded = ["className", "children"];

var Text = function Text(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_typography.default, (0, _extends2.default)({
    className: className,
    style: props,
    role: "button"
  }, props), (0, _reactHtmlParser.default)(children));
};

Text.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any.isRequired
};

var _default = (0, _styledComponents.default)(Text).withConfig({
  displayName: "Text",
  componentId: "sc-1yatk6i-0"
})(["display:inline;> a{color:inherit;font-size:inherit;font-weight:inherit;text-decoration:none;border-bottom:1px dashed #999;:hover{border-bottom:1px solid #999;cursor:pointer;}}"]);

exports.default = _default;